/**
 * Created by Languagenut on 22/03/2019.
 */


import React  from 'react';
import {Media , Navbar , Form , Button , Card , Row , Col , Nav , ButtonGroup} from 'react-bootstrap'
import Slider from "react-slick";
import LazyHero from 'react-lazy-hero';
import {StoreNavigation} from '../components';
import {NewApps , FeaturedApps , CollectionApps } from '../components/apps';

export default class AccountAppStore extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {

        };
    }

    componentDidMount() {

    }

    componentWillReceiveProps(props){

    }

    onNavigationSelect(){


    }

    render(){

        var settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        };
        return (
            <div>
                <LazyHero className="shadow">
                    <table>
                        <tr>
                        <td></td>
                        <td>
                            <img style={{height:"200px"}} src="/example_badge.png" />
                            <br/>
                            <br/>
                            <h5>Rustington Primary School</h5>
                            <h6>short description</h6>
                            <small>powered by <a className="hyperlink" href="">Languagenut LTD</a></small>
                        </td>
                        <td >
                        </td>
                        </tr>
                    </table>
                </LazyHero>
                <br/>
                <StoreNavigation/>
                <br/>
                <Card body className="shadow">
                <NewApps title="Most Recent"/>
                </Card>
                <br/>
                <Card body className="shadow">
                    <NewApps title="Featured"/>
                </Card>
                <br/>
                <Card body className="shadow">
                    <Card.Title>Classes and Clubs</Card.Title>
                    <NewApps />
                <br/>
                    <NewApps />
                <br/>
                    <NewApps />
                <br/>
                    <NewApps />
                    <br/>
                </Card>
                {/* ... */}
            </div>
        );


    }

}